import { IndexFormat } from "./RenderEnum/IndexFormat";
import { Buffer } from "./Buffer";
export class IndexBuffer extends Buffer {
    constructor(targetType, bufferUsageType) {
        super(targetType, bufferUsageType);
        this._indexType = IndexFormat.UInt16;
    }
}
